import { useAlert } from './useAlert';
import { useAuth } from '../utils/authContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

export function useLogin() {
    const { showAlert } = useAlert();
    const { login, logout } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleLogout = async () => {
        try {
            navigate('/');
            await logout();
            showAlert('Erfolgreich ausgeloggt', 'success');
        } catch (error) {
            showAlert('Logout fehlgeschlagen', 'error');
        }
    };

    const handleSubmit = async (event, email, password) => {
        event.preventDefault();
        if (!email || !password) {
            showAlert('Bitte füllen Sie alle Felder aus.', 'error');
            return;
        }
        
        try {
            const res = await login({ email, password });

            if (res?.data?.token) {
                showAlert('Erfolgreich eingelogged', 'success');

                const userRole = res.data.data.user.role;
                const onboardCompleted = res.data.data.user.onboardCompleted;
                let redirectPath = '/dashboard';

                if (!onboardCompleted) {
                    redirectPath = '/register/onboard';
                } else if (userRole === 'admin') {
                    redirectPath = '/admin/dashboard';
                }
                
                return setTimeout(() => navigate(redirectPath), 1000);
            } else {
                showAlert('Login fehlgeschlagen', 'error');
            }
            
        } catch (error) {
            const code = error?.response?.data?.code;
            const msg = error?.response?.data?.message || 'Fehler beim Einloggen';

            if (code === 'ACCOUNT_INACTIVE') {
                showAlert('Dein Account ist deaktiviert. Bitte kontaktiere den Support.', 'error');
            } else if (code === 'EMAIL_NOT_CONFIRMED') {
                showAlert('Bitte bestätige zuerst deine E-Mail-Adresse.', 'error');
            } else {
                showAlert(msg, 'error');
            }
        }
    };

    const forgotPassword = async (email) => {
        if (!email) {
            showAlert('Bitte geben Sie Ihre E-Mail-Adresse ein.', 'error');
            return;
        }

        try {
            await axios({
                method: 'POST',
                url: `${API_URL}/users/forgotPassword`,
                data: {
                    email,
                },
                withCredentials: true,
            });
            showAlert('Passwort-Zurücksetzungslink wurde an Ihre E-Mail gesendet.', 'success');
        } catch (error) {
            showAlert('Fehler beim Zurücksetzen des Passworts.', 'error');
        }
    };

    const handleRegister = async (event, prename, name, email, password, passwordConfirm) => {
        event.preventDefault();
        if (!name || !prename || !email || !password || !passwordConfirm) {
            showAlert('Bitte füllen Sie alle Felder aus.', 'error');
            return;
        }

        if (password !== passwordConfirm) {
            showAlert('Passwörter stimmen nicht überein', 'error');
            return;
        }
        
        try {
            const res = await axios({
                method: 'POST',
                url: `${API_URL}/users/signup`,
                withCredentials: true,
                data: {
                    name,
                    prename,
                    email,
                    password,
                    passwordConfirm
                },
            });

            if (res.data.status === 'success') {
                showAlert('Registrierung erfolgreich! Bitte bestätige deine E-Mail-Adresse.', 'success');
                setTimeout(() => navigate('/register/confirm-email'), 1000);
            } else {
                showAlert('Registrierung fehlgeschlagen', 'error');
            }
        } catch (error) {
            showAlert('Ein Fehler ist aufgetreten', 'error');
        }
    };

    const resetPassword = async (token, password, passwordConfirm) => {
        try {
            await axios.patch(`${API_URL}/users/resetPassword/${token}`, {
                password,
                passwordConfirm,
            });
            showAlert('Passwort erfolgreich zurückgesetzt!', 'success');
            setSuccess(true);
            setTimeout(() => navigate('/login'), 1500);
        } catch (error) {
            setError('Fehler beim Zurücksetzen des Passworts.');
            console.log(error)
            throw error;
        }
    };

    const confirmEmail = async (token) => {
        try {
            await axios.get(`${API_URL}/users/confirm-email/${token}`);
            setSuccess(true);
        } catch (err) {
            setError('Ungültiger oder abgelaufener Email-Token.');
        }
    };
    
    const validateResetToken = async (token) => {
      try {
        await axios.get(`${API_URL}/users/validateResetToken/${token}`);
        setError('');
      } catch (err) {
        setError('Ungültiger oder abgelaufener Passwort-Token.');
      }
    };

    return { handleLogout, handleSubmit, forgotPassword, handleRegister, validateResetToken, resetPassword, confirmEmail, success, error };
};